import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import ThemeContext from "../ThemeContext/index";
import "./utils/focus-visible";
import { Global } from "@emotion/react";
export var ThemeProvider = function(param) {
    var theme = param.theme, children = param.children;
    var ref, ref1, ref2, ref3;
    return _jsxs(ThemeContext.Provider, {
        value: theme,
        children: [
            _jsx(Global, {
                styles: {
                    '.js-focus-visible :focus:not(.focus-visible)': {
                        boxShadow: 'none',
                        outline: 'none'
                    },
                    '.focus-visible': {
                        transitionProperty: 'box-shadow, outline',
                        transitionDuration: theme === null || theme === void 0 ? void 0 : (ref = theme.animation) === null || ref === void 0 ? void 0 : ref.duration[100],
                        transitionTimingFunction: theme === null || theme === void 0 ? void 0 : (ref1 = theme.animation) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.productive) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.easeInOut) === null || ref3 === void 0 ? void 0 : ref3.easing
                    }
                }
            }),
            children
        ]
    });
};
export default ThemeProvider;
